import React from 'react';
import classnames from 'classnames';
import './Option.scss';
import DisplayItem from './DisplayItem';

const cbn = 'form-station-selector-option';

type FormStationSelectorOptionProps = {
  innerRef: React.Ref<HTMLButtonElement>;
  data: {
    id: string;
    displayName: string;
    type: string;
    country: string;
    image: string;
  };
  innerProps: object;
  isDisabled: boolean;
  isFocused: boolean;
  isSelected: boolean;
};

function FormStationSelectorOption({
  data,
  innerProps,
  innerRef,
  isDisabled = false,
  isFocused = false,
  isSelected = false,
}: Readonly<FormStationSelectorOptionProps>) {
  return (
    <button
      type="button"
      ref={innerRef}
      {...innerProps}
      className={classnames(cbn, {
        [`${cbn}--is-focused`]: isFocused,
        [`${cbn}--is-selected`]: isSelected,
        [`${cbn}--is-disabled`]: isDisabled,
      })}
    >
      <DisplayItem
        name={data.displayName}
        type={data.type}
        country={data.country}
        stationIcon={data.image}
      />
    </button>
  );
}

export default FormStationSelectorOption;
